const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ArjeeApi = {
  OneTimeEdit: `${BASE_URL}/v3/one-time/edit`,
  OneTimeCreate: `${BASE_URL}/v3/one-time/create`,
  OneTimeVerify: `${BASE_URL}/v3/one-time/verify`,
  DainikEdit: `${BASE_URL}/dainik-arjee/edit`,
  DainikCancel: `${BASE_URL}/dainik-arjee/cancel`,
  DainikCreate: `${BASE_URL}/dainik-arjee/create`,
  DainikVerify: `${BASE_URL}/dainik-arjee/verify`,
  RazorpayDainikCreate: `${BASE_URL}/v3/razorpay-dainik-arjee/create`,
  RazorpayDainikVerify: `${BASE_URL}/v3/razorpay-dainik-arjee/verify`,
  RazorpayDainikCancel: `${BASE_URL}/v3/razorpay-dainik-arjee/cancel`,
  RazorpayDainikEdit: `${BASE_URL}/v3/razorpay-dainik-arjee/edit`,
  VyaktigatSlots: `${BASE_URL}/user/getSlots`,
  VyaktigatCreate: `${BASE_URL}/v3/vyaktigat-arjee/create`,
  VyaktigatVerify: `${BASE_URL}/v3/vyaktigat-arjee/verify`,
  VyaktigatEdit: `${BASE_URL}/v3/vyaktigat-arjee/edit`,
  VyaktigatDetails: `${BASE_URL}/v3/vyaktigat-arjee/details`,
  EkadashiCreate: `${BASE_URL}/v3/ekadashi-arjee/create`,
  EkadashiVerify: `${BASE_URL}/v3/ekadashi-arjee/verify`,
  EkadashiEdit: `${BASE_URL}/v3/ekadashi-arjee/edit`,
  EkadashiCancel: `${BASE_URL}/v3/ekadashi-arjee/cancel`,
  EkadashiDetails: `${BASE_URL}/v3/ekadashi-arjee/details`,
};

export const BheedApi = {
  Bheed: `${BASE_URL}/user/bheed-bhad`,
  BheedByDate: (date) => `${BASE_URL}/user/bheed-bhad/${date}`,
};

export const MiscApi = {
  FeedbackSubmit: `${BASE_URL}/feedback/submit`,
};

export const UserApi = {
  GetVideo: `${BASE_URL}/user/getVideo`,
  GetVAVideo: `${BASE_URL}/user/get-va-video`,
  Dashboard: `${BASE_URL}/user/dashboard`,
  Delete: `${BASE_URL}/user/delete`,
  Edit: `${BASE_URL}/user/edit`,
  GetImages: `${BASE_URL}/user/getImages`,
  GetGalleryImages: `${BASE_URL}/user/getGalleryImages`,
  SendPhoneOtp: `${BASE_URL}/auth/sendotp`,
  VerifyPhoneOtp: `${BASE_URL}/auth/verifyotp`,
  EmailLogin: `${BASE_URL}/auth/email`,
  GoogleLogin: `${BASE_URL}/auth/google`,
  UpdateProfilePic: `${BASE_URL}/user/update-profile-image`,
};

export const ReviewsApi = {
  ArjeeReviews: `${BASE_URL}/reviews/arjee-reviews`,
  Review: `${BASE_URL}/reviews/my-review`,
  Reviews: `${BASE_URL}/reviews/my-reviews`,
  HomeReviews: `${BASE_URL}/reviews/home-reviews`,
};

export const CreatorApi = {
  Dashboard: `${BASE_URL}/creator/dashboard`,
  UpdateDetails: `${BASE_URL}/creator/updateDetails`,
  GenerateLink: `${BASE_URL}/creator/generateLink`,
  Login: `${BASE_URL}/creator/login`,
};

export const PaymentApi = {
  CancelOrder: `${BASE_URL}/payments/cancelOrder`,
  Payment: `${BASE_URL}/v3/pay-online`,
  Verify: `${BASE_URL}/v3/pay-verify`,
  COD: `${BASE_URL}/v3/paymentcod`,
  BhogCreate: `${BASE_URL}/v3/bhog-create`,
  BhogVerify: `${BASE_URL}/v3/bhog-verify`,
};

export const SwayamArjeeApi = {
  Edit: `${BASE_URL}/v3/swayam-arjee/edit`,
  Change: `${BASE_URL}/v3/swayam-arjee/change`,
  Create: `${BASE_URL}/v3/swayam-arjee/create`,
  Verify: `${BASE_URL}/v3/swayam-arjee/verify`,
};

// export const LakhiMelaApi = {
// GetUpdates: `${BASE_URL}/user/lakhi-mela`,
// };

export const ParamStaysApi = {
  CreateBooking: `${BASE_URL}/v3/param-stays/create-booking`,
  VerifyBooking: `${BASE_URL}/v3/param-stays/verify-booking`,
  CheckAvalibility: `${BASE_URL}/v3/param-stays/check-avaliable-rooms`,
};

export const PanBhogApi = {
  Create: `${BASE_URL}/v3/panBhog/create`,
  Verify: `${BASE_URL}/v3/panBhog/verify`,
};

export const ParamSevakApi = {
  Chat: `${BASE_URL}/paramsevak/chat`,
};

export const NotificationApi = {
  RegisterToken: `${BASE_URL}/notifications/register-token`,
  RemoveToken: `${BASE_URL}/notifications/remove-token`,
  MyNotifications: `${BASE_URL}/notifications/my-notifications`,
  MarkRead: `${BASE_URL}/notifications/mark-read`,
};

export const CallbackApi = {
  Request: `${BASE_URL}/v1/callback/request`,
};

export const BlogApi = {
  GetBlogs: `${BASE_URL}/blog`,
  GetBlogBySlug: (slug) => `${BASE_URL}/blog/${slug}`,
  LikeBlog: (id) => `${BASE_URL}/blog/${id}/like`,
  UnlikeBlog: (id) => `${BASE_URL}/blog/${id}/unlike`,
};

export const DataApi = {};

export const CouponApi = {
  Validate: `${BASE_URL}/coupon/validate`,
};

export const SwayamCreatorApi = {
  SendOtp: `${BASE_URL}/swayam-creator/sendotp`,
  VerifyOtp: `${BASE_URL}/swayam-creator/verifyotp`,
  Dashboard: `${BASE_URL}/swayam-creator/dashboard`,
};

export const BhogArjeeApi = {
  Create: `${BASE_URL}/v3/bhog-arjee/create`,
  Verify: `${BASE_URL}/v3/bhog-arjee/verify`,
  Edit: `${BASE_URL}/v3/bhog-arjee/edit`,
};

export const MapApi = {
  Nodes: `${BASE_URL}/map-routes/nodes`,
  FindPath: `${BASE_URL}/map-routes/find-path`,
  Directions: `${BASE_URL}/map-routes/directions`,
  TileProxy: `${BASE_URL}/map-routes/tiles`,
  Navigate: `${BASE_URL}/map-routes/navigate`,
  Search: `${BASE_URL}/map-routes/search`,
  Reports: `${BASE_URL}/map-routes/reports`,
};

